import classNames from 'classnames';

interface IconProps {
    className?: string | null;
}

function Lunettes({ className = null }: IconProps) {
    return (
        <svg
            className={classNames([{ [className]: className !== null }])}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 180.07 180.07"
        >
            <defs>
                <filter
                    id="drop-shadow-lunettes"
                    x="0"
                    y="0"
                    width="180.07"
                    height="180.07"
                    filterUnits="userSpaceOnUse"
                >
                    <feOffset dx="5" dy="5" />
                    <feGaussianBlur result="blur" stdDeviation="0" />
                    <feFlood floodColor="#0a0a26" floodOpacity="1" />
                    <feComposite in2="blur" operator="in" />
                    <feComposite in="SourceGraphic" />
                </filter>
            </defs>
            <polygon
                points="87.54 2.86 104.15 47.42 147.41 27.66 127.66 70.92 172.21 87.54 127.66 104.15 147.41 147.41 104.15 127.66 87.54 172.21 70.92 127.66 27.66 147.41 47.42 104.15 2.86 87.54 47.42 70.92 27.66 27.66 70.92 47.42 87.54 2.86"
                fill="#928df7"
                filter="url(#drop-shadow-lunettes)"
                stroke="#000"
                strokeMiterlimit="10"
                strokeWidth="2"
            />
        </svg>
    );
}

export default Lunettes;
